import {AbModalConfigInterface} from "@/scripts/modules/ab-modal/ab-modal.types";
import {createDomElementHandler} from "@/scripts/utils/dom.utils";
import {AbModal} from "@/scripts/modules/ab-modal/ab-modal.class";
import {AbLensCompatibilityElement} from "@/scripts/components/ab-lens-compatibility/abLensCompatibility.element";
import {AbLensCompatibilityUpdateEvDetail} from "@/scripts/components/ab-lens-compatibility/abLensCompatibility.types";

export class AbLensCompatibilityInModal {

  private modalConfig: AbModalConfigInterface = {
    autoOpen: false,
    handleBackBrowser: true,
    hideBodyOverflow: true,
    id: '',
    attributes: {
      classesWrapper: '',
      classesModal: 'ab-modal--md',
      classesBackdrop: 'ab-modal__backdrop--light-75',
      classesInner: '',
      header: {
        show: true,
        classes: '',
        text: "Compatibilità Obiettivo",
        closeButtonText: 'chiudi',
        closeButton: true,
      },
    }
  }

  constructor(options: { productid: string;  }) {
    this.modalConfig.id = "compatibilita-obiettivo";

    const lensCompatibilityElement = createDomElementHandler( 'ab-lens-compatibility', [],
      {
        "productid": options.productid,
        "auto-open": 'true'
      }) as AbLensCompatibilityElement;

    const modal = new AbModal(this.modalConfig, lensCompatibilityElement);
    modal.show();

    lensCompatibilityElement
      .addEventListener("ab-lens-compatibility-updated", ( event: Event) => {
        const { lens, camera } = (event as CustomEvent<AbLensCompatibilityUpdateEvDetail>).detail;
        const lensName = lens.productData.names?.at(0);
        if(!lensName?.length) return;
        const cameraName = camera?.productData?.names?.at(0);
        let newModalTitle = `Compatibilità <strong>${lensName}</strong>`;
        if( cameraName?.length) {
          newModalTitle += ` con <strong>${cameraName}</strong>`;
        }
        modal.updateTitle(newModalTitle);
    });
  }

}